import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }              from '../api/api.service';
import { CarfaxSettingsComponent } from './carfax.settings.component';
import { CodeTypeModel }           from '../core/models/code-type';
import { SessionService }          from '../sessions/session.service';

export const CarfaxStates : Array<NgHybridStateDeclaration> = [
  {
    component: CarfaxSettingsComponent,
    name     : 'app.carfax',
    resolve  : [
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<any> => apiService.get('/company'),
        token    : 'company'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<Array<CodeTypeModel>> => apiService.get('/system/state_types', null, 'states'),
        token    : 'states'
      },
    ],
    url: '/carfax'
  }
];
